 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"c5c9eb4c","chunk-19b0cf18":"dc1cd955","chunk-1c9306cf":"cbfa0e2c","chunk-266544bb":"81563b71","chunk-2d0aab45":"081c400c","chunk-2d0cc1d9":"47f78453","chunk-2f45ca58":"1d2e724e","chunk-2fd16595":"1c4ebda7","chunk-37590406":"2002d1c0","chunk-3d370fbd":"286136a8","chunk-4005715d":"e5bf737d","chunk-43701c8e":"876fbf20","chunk-4fc4313d":"30d33fd3","chunk-5069aa76":"58bc9c23","chunk-52b22ba5":"0ef763f0","chunk-75fa76d9":"9fe23af2","chunk-7aa1d62d":"46528bcf","chunk-7f86371a":"03503c0b","chunk-b36c5926":"5bde928c","chunk-commons~d939e436":"8de2a971","chunk-commons~f71cff67":"be4de338","chunk-commons~21833f8f":"55a7e209","chunk-commons~447143dd":"eb740b22","chunk-03210516":"fa5eeb16","chunk-058516b8":"e13dbb6c","chunk-078c5397":"f722f144","chunk-1549ede6":"df0a9c92","chunk-19447ea9":"4c352d9f","chunk-1c791567":"d8cfc9f1","chunk-263a6f66":"21519cf5","chunk-278f15c2":"4f46566d","chunk-2d0a30ec":"2a394fc7","chunk-2d0c917a":"7d067a5a","chunk-2d0da362":"6ef83593","chunk-2d0daf52":"3296c6d8","chunk-2d0e4810":"8f77e3e5","chunk-2d0efccf":"07df35e2","chunk-2d207d1a":"18318c50","chunk-2d2140d8":"7cf0b6d5","chunk-2d217776":"8e94a9fa","chunk-2d226c7a":"e591d616","chunk-3576d672":"5878355e","chunk-3d004363":"10e80968","chunk-43fbcfb2":"4fa8b83e","chunk-46a258dd":"eb1dcd88","chunk-4a5f46a6":"0e02ff91","chunk-ea8f7f04":"8db829da","chunk-4c1f05b6":"bc112925","chunk-5531d079":"d9aa0cd9","chunk-5f9765f4":"21232199","chunk-5fa479c5":"8df8c947","chunk-6627835c":"6d5ee188","chunk-76fab7fa":"7a22acd7","chunk-7b23f141":"55960dfa","chunk-7e181d1d":"0cf5f19a","chunk-a2103720":"e63ca1c1","chunk-c5e4ae26":"fbcd2fe6","chunk-ef8735dc":"f6c2dcb6","chunk-ffdacf1e":"d15a07e3","home~21833f8f":"decefbb3","sentiment~21833f8f":"5a75db4b","user~6e76d53f":"980ec252","wonder~a0a3fe25":"cd610eac","chunk-d36bd4fa":"635a4de3","chunk-0130496c":"4e539668"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05a29214":1,"chunk-19b0cf18":1,"chunk-1c9306cf":1,"chunk-266544bb":1,"chunk-2f45ca58":1,"chunk-37590406":1,"chunk-3d370fbd":1,"chunk-4005715d":1,"chunk-43701c8e":1,"chunk-4fc4313d":1,"chunk-52b22ba5":1,"chunk-75fa76d9":1,"chunk-7aa1d62d":1,"chunk-7f86371a":1,"chunk-b36c5926":1,"chunk-commons~f71cff67":1,"chunk-commons~21833f8f":1,"chunk-commons~447143dd":1,"chunk-03210516":1,"chunk-058516b8":1,"chunk-078c5397":1,"chunk-1549ede6":1,"chunk-19447ea9":1,"chunk-1c791567":1,"chunk-263a6f66":1,"chunk-278f15c2":1,"chunk-3576d672":1,"chunk-3d004363":1,"chunk-43fbcfb2":1,"chunk-46a258dd":1,"chunk-ea8f7f04":1,"chunk-4c1f05b6":1,"chunk-5531d079":1,"chunk-5f9765f4":1,"chunk-5fa479c5":1,"chunk-6627835c":1,"chunk-76fab7fa":1,"chunk-7b23f141":1,"chunk-7e181d1d":1,"chunk-a2103720":1,"chunk-c5e4ae26":1,"chunk-ef8735dc":1,"chunk-ffdacf1e":1,"home~21833f8f":1,"sentiment~21833f8f":1,"user~6e76d53f":1,"wonder~a0a3fe25":1,"chunk-d36bd4fa":1,"chunk-0130496c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"20d2b46c","chunk-19b0cf18":"3a86a2cb","chunk-1c9306cf":"7e561068","chunk-266544bb":"2f2e42d6","chunk-2d0aab45":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2f45ca58":"3c8c4dca","chunk-2fd16595":"31d6cfe0","chunk-37590406":"d9b759b3","chunk-3d370fbd":"064cab12","chunk-4005715d":"f96e9b7e","chunk-43701c8e":"d04338fa","chunk-4fc4313d":"80994280","chunk-5069aa76":"31d6cfe0","chunk-52b22ba5":"e9580f07","chunk-75fa76d9":"0f317b67","chunk-7aa1d62d":"fb53adac","chunk-7f86371a":"0ba3e99d","chunk-b36c5926":"1d2909f2","chunk-commons~d939e436":"31d6cfe0","chunk-commons~f71cff67":"33cb4d0d","chunk-commons~21833f8f":"483e6ad3","chunk-commons~447143dd":"3353912f","chunk-03210516":"78718bd2","chunk-058516b8":"0fe3e47d","chunk-078c5397":"5b54aec7","chunk-1549ede6":"b79eb2bf","chunk-19447ea9":"eefe5e95","chunk-1c791567":"2c606da0","chunk-263a6f66":"0a184d0d","chunk-278f15c2":"5c5c2664","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-3576d672":"a64067e4","chunk-3d004363":"5f3458e3","chunk-43fbcfb2":"43d684f4","chunk-46a258dd":"d2558648","chunk-4a5f46a6":"31d6cfe0","chunk-ea8f7f04":"c36a80f3","chunk-4c1f05b6":"bbb450a4","chunk-5531d079":"939147fd","chunk-5f9765f4":"eef13baa","chunk-5fa479c5":"503fdf5f","chunk-6627835c":"1463a986","chunk-76fab7fa":"40015950","chunk-7b23f141":"166dc5d7","chunk-7e181d1d":"e3dcf7c2","chunk-a2103720":"17e83b19","chunk-c5e4ae26":"f2752c87","chunk-ef8735dc":"495a8d42","chunk-ffdacf1e":"9773d51b","home~21833f8f":"7ef99428","sentiment~21833f8f":"ffccecf4","user~6e76d53f":"9a17f1c6","wonder~a0a3fe25":"fdbc7a44","chunk-d36bd4fa":"e18b6095","chunk-0130496c":"61a4f04c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
